import { useSettings } from "@Tmp/Hooks";
import Tooltip from "@Tmp/Tooltip";
import * as React from "react";
import { PriceProps } from "./Price.types";

const Price: React.FC<PriceProps> = ({
    rawPriceText,
    inclVatPriceText,
    exVatPriceText,
    prependPrice = "",
    appendPriceText = "",
    price = null,
    hideDiscount = false,
    product,
    ...props
}) => {
    const tmpSettings = useSettings();

    rawPriceText = rawPriceText
        ? rawPriceText
        : props.settings?.price_raw_price_text ?? "Vejl. inkl. moms.";
    inclVatPriceText = inclVatPriceText
        ? inclVatPriceText
        : props.settings?.price_incl_vat_price_text ?? "Inkl. moms.";
    exVatPriceText = exVatPriceText
        ? exVatPriceText
        : props.settings?.price_ex_vat_price_text ?? "Netto. ekskl. moms.";

    const printPrice = () => {
        return (
            <span className="tmp-price">
                <small className="tmp-price-number">
                    {prependPrice ? (
                        <span className="tmp-price-text-before">{prependPrice}</span>
                    ) : null}
                    <span>
                        {price
                            ? price
                            : product.price_info.price_format + " " + tmpSettings.currency}
                    </span>
                    <span className="tmp-price-text-after">
                        {(tmpSettings.logged_in ? exVatPriceText : inclVatPriceText) +
                            appendPriceText}
                    </span>
                    {props.settings?.dealer_tooltip_price ? (
                        tmpSettings.logged_in ? (
                            <Tooltip>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: props.settings?.dealer_tooltip_price,
                                    }}
                                ></div>
                            </Tooltip>
                        ) : (
                            <Tooltip>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: props.settings?.tooltip_price,
                                    }}
                                ></div>
                            </Tooltip>
                        )
                    ) : null}
                </small>
            </span>
        );
    };

    const printRawPrice = () => {
        return (
            <>
                <br />
                <span className="tmp-price tmp-price-discount">
                    <small>
                        {prependPrice ? (
                            <span className="tmp-price-text-after">{prependPrice}</span>
                        ) : null}
                        <span className="tmp-price-number">
                            {product.price_info.raw_retail_price_format +
                                " " +
                                tmpSettings.currency}
                        </span>
                        <span className="tmp-price-text-after">
                            {rawPriceText + appendPriceText}
                        </span>
                        {props.settings?.tooltip_price_discount ? (
                            <Tooltip>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: props.settings?.tooltip_price_discount,
                                    }}
                                ></div>
                            </Tooltip>
                        ) : null}
                    </small>
                </span>
            </>
        );
    };

    if (product?.is_shop_disabled) {
        return null;
    }

    return (
        <div className="tmp-price-container">
            {printPrice()}
            {product?.price_info?.has_discount && hideDiscount === false ? printRawPrice() : null}
        </div>
    );
};

export default Price;
